/** Duelist portrait: a LOB card's artwork window plus a square frame. */

export interface AvatarConfig {
  cardId: string
  frameId: string
  /**
   * Revision of the uploaded exclusive portrait. Omitted for card art and
   * until that account stores an image. Clients use it as a cache-buster.
   */
  rev?: number
}

/** Artwork box on a TCG scan, as fractions of the full card. */
export const CARD_ART_CROP = {
  x: 0.108,
  y: 0.176,
  w: 0.786,
  h: 0.536,
} as const

/** Pixel size of the LOB scans in `client/public/card-images`. */
export const CARD_SCAN_WIDTH = 813
export const CARD_SCAN_HEIGHT = 1185

/** Width / height of that box on the LOB scans. */
export const CARD_ART_ASPECT =
  (CARD_ART_CROP.w * CARD_SCAN_WIDTH) / (CARD_ART_CROP.h * CARD_SCAN_HEIGHT)

/** Border thickness as a fraction of the square portrait. */
export const AVATAR_FRAME_INSET = 0.12

/** Full-screen VS hold before dice / opening deal. Skip ends it early. */
export const VS_INTRO_MS = 3500

/**
 * Side-by-side roster hold after the VS intro. The server always waits this
 * long so the clock does not start under the cards. Skip ends it early on the client.
 */
export const ROSTER_INTRO_MS = 5900
